export default __webpack_public_path__ + "static/nasscom_thumb-fa3e87d593d3d1a5a44e106082db8afe.png";